import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "fs16 mt20 fw600" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, "ファイルURLを入力", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "GoogleスプレッドシートのURLもしくはファイルIDを入力してください。", -1)
const _hoisted_6 = {
  key: 2,
  class: "fl fs12 fw600"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt40 fw600" }, "書き込みルール", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, " 更新があった場合に上書きする行名を探索し、その行を更新します。選択された項目がない場合は、新たに行を追加します。 ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt40 fw600" }, "列を選択", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 上から1行ごとに、A列から書き込む内容を指定します。空白の場合、更新しません。必ず書き込みルールで選択した項目を記載するようにしてください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 例: "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs12 grey" }, [
    /*#__PURE__*/_createTextVNode(" <<調整ページID>>"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" <<出席者-1-氏名>>"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 調整済み"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" <<確定開始日時>>"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" <<発行されたオンライン会議URL>>"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" <<担当者名>>"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_14 = { class: "mt20" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "確定時", -1)
const _hoisted_17 = {
  key: 0,
  class: "grey"
}
const _hoisted_18 = {
  key: 1,
  class: "mt20"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs11 label dblueBg" }, "確定時", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = { class: "mt20" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "完了時", -1)
const _hoisted_28 = {
  key: 0,
  class: "grey"
}
const _hoisted_29 = {
  key: 1,
  class: "mt20"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs11 label dblueBg" }, "完了時", -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = { class: "mt20" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "キャンセル/再調整時", -1)
const _hoisted_38 = {
  key: 0,
  class: "grey"
}
const _hoisted_39 = {
  key: 1,
  class: "mt20"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs11 label dblueBg" }, "キャンセル/再調整時", -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_VariableListsContent = _resolveComponent("VariableListsContent")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/google_spread.png`),
        width: "20",
        height: "28",
        class: "pointer fl mr10",
        style: {"margin-top":"-8px"}
      }, null, 8, _hoisted_3),
      _createTextVNode("Googleスプレッドシート連携設定 ")
    ]),
    _hoisted_4,
    _createElementVNode("div", null, [
      _hoisted_5,
      _createVNode(_component_MdTextfieldTag, {
        id: "google_spread_sheet_url",
        class: "fl fs14 mr10",
        fieldStyle: "min-width:250px;max-width:250px;",
        style: {"height":"56px","min-width":"250px"},
        value: _ctx.sheetUrl,
        onInputValue: _ctx.inputSheetGoogleSpreadSheetUrl
      }, null, 8, ["value", "onInputValue"]),
      (_ctx.selectedFile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`fl ${_ctx.selectedFile ? `skyblueBg` : `greyBg`} rad5 mt20 fs11 pointer hoverGreyBg mr10`),
            style: {"padding":"13px","height":"40px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reselectFile && _ctx.reselectFile(...args)))
          }, " 再選択 ", 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(`fl ${_ctx.sheetUrl ? `skyblueBg` : `greyBg`} rad5 mt10 fs11 pointer hoverGreyBg mr10`),
            style: {"padding":"13px","height":"40px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decideFile && _ctx.decideFile(...args)))
          }, " 決定 ", 2)),
      (_ctx.selectedFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "「" + _toDisplayString(_ctx.selectedFile.name) + "」が紐づいています", 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_7,
    (_ctx.selectedFile && !_ctx.displayFiles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_SelectTag, {
              name: "check_field_type",
              id: "select_check_field_type",
              class: "fl fs14 roundForm mt15 mr5",
              style: {"min-width":"50px","height":"50px"},
              options: (_ctx.SelectUtil.checkFieldTypes || []).map(seldic => seldic.name),
              defaultOption: _ctx.checkFieldTypeDefaultOption(),
              needUnselect: false,
              onSelectValue: _ctx.selectCheckFieldType
            }, null, 8, ["options", "defaultOption", "onSelectValue"])
          ]),
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", null, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              (!_ctx.openFixedAppointmentContent)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mt20 pointer pad10 borderGrey rad8 hoverLgreyBg",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openContent(`fixed_appointment`)))
                  }, [
                    _hoisted_16,
                    (_ctx.sheetSettings?.fixed_appointment?.content)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.truncate(_ctx.sheetSettings?.fixed_appointment?.content, 10)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", {
                      class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addVal(`fixed_appointment`)))
                    }, " +変数を追加 "),
                    (_ctx.openVariablesFixedAppointment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_VariableListsContent, {
                            onSelectVariable: _ctx.selectVariable,
                            type: `fixed_appointment`
                          }, null, 8, ["onSelectVariable"]),
                          _hoisted_21
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_22,
                    _createVNode(_component_TextareaTag, {
                      name: "fixed_appointment",
                      id: "textarea_fixed_appointment",
                      class: "fl fs14 roundForm mw100",
                      style: `height:300px;`,
                      value: _ctx.sheetSettings?.fixed_appointment?.content,
                      onInputValue: _ctx.inputSheetFixedAppointment
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_23
                  ])),
              _hoisted_24
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (!_ctx.openInquireOnPublicRoomContent)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mt20 pointer pad10 borderGrey rad8 hoverLgreyBg",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openContent(`inquire_on_public_room`)))
                  }, [
                    _hoisted_27,
                    (_ctx.sheetSettings?.inquire_on_public_room?.content)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.truncate(_ctx.sheetSettings?.inquire_on_public_room?.content, 10)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", {
                      class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addVal(`inquire_on_public_room`)))
                    }, " +変数を追加 "),
                    (_ctx.openVariablesInquireOnPublicRoom)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createVNode(_component_VariableListsContent, {
                            onSelectVariable: _ctx.selectVariable,
                            type: `inquire_on_public_room`
                          }, null, 8, ["onSelectVariable"]),
                          _hoisted_32
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_33,
                    _createVNode(_component_TextareaTag, {
                      name: "inquire_on_public_room",
                      id: "textarea_inquire_on_public_room",
                      class: "fl fs14 roundForm mw100",
                      style: `height:300px;`,
                      value: _ctx.sheetSettings?.inquire_on_public_room?.content,
                      onInputValue: _ctx.inputSheetInquireOnPublicRoom
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_34
                  ]))
            ]),
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              (!_ctx.openCancelAppointmentContent)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mt20 pointer pad10 borderGrey rad8 hoverLgreyBg",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openContent(`cancel_appointment`)))
                  }, [
                    _hoisted_37,
                    (_ctx.sheetSettings?.cancel_appointment?.content)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.truncate(_ctx.sheetSettings?.cancel_appointment?.content, 10)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("div", {
                      class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addVal(`cancel_appointment`)))
                    }, " +変数を追加 "),
                    (_ctx.openVariablesCancelAppointment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createVNode(_component_VariableListsContent, {
                            onSelectVariable: _ctx.selectVariable,
                            type: `cancel_appointment`
                          }, null, 8, ["onSelectVariable"]),
                          _hoisted_42
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_43,
                    _createVNode(_component_TextareaTag, {
                      name: "cancel_appointment",
                      id: "textarea_cancel_appointment",
                      class: "fl fs14 roundForm mw100",
                      style: `height:300px;`,
                      value: _ctx.sheetSettings?.cancel_appointment?.content,
                      onInputValue: _ctx.inputSheetCancelAppointment
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_44
                  ]))
            ])
          ]),
          _hoisted_45
        ]))
      : _createCommentVNode("", true)
  ]))
}